export enum AssignTradeMode {
  JobPost,
  EditOnJobPost,
  ApproveJob,
  ReAwardJob,
  OwnerOverride,
}

export enum JobDetailsMode {
  NONE,
  EDIT,
}
